const Sdata = [

    {
        img:'https://cdn.dribbble.com/users/2069402/screenshots/5574718/gif-4mb.gif',
        name: 'Full Stack Web Development',
        description:'The full stack developer definition is “someone who can work on both the back-end and front-end of systems.'
    },
    {
        img:'https://www.hiddenbrains.com/blog/wp-content/uploads/2019/07/kotlin-for-android-app-development.gif',
        name:'Android Development',
        description:'Android OS is a Linux-based mobile operating system that primarily runs on smartphones and tablets'
    }
    ,
    {
        img:'https://i.pinimg.com/originals/2a/53/65/2a53651a35816f499270d8275fd5318f.gif',
        name:'Software Development',
        description:'A Software Developer designs and builds computer programs that power mobile devices, desktop computers, and even cars.'
    },
    {
        img:'https://media3.giphy.com/media/gHiRWOaXGGHOY5w6f3/giphy.gif',
        name:'Digital Marketing',
        description:'Digital marketing, also called online marketing, is the promotion of brands to connect with potential customers using the internet and other forms of digital communication.'
    },
    {
        img:'https://cdn.dribbble.com/users/176039/screenshots/9022929/media/b21392d51355d99c7b82a5fedf2c4f85.gif',
        name:'Data Science',
        description:'Data science is the study of data to extract meaningful insights for business. It is a multidisciplinary approach that combines principles and practices from the fields of mathematics, statistics, artificial intelligence.'
    },
    {
        img:'https://ismuniv.com/wp-content/uploads/2021/12/dm.gif',
        name:'Marketing',
        description:'Marketing refers to activities a company undertakes to promote the buying or selling of a product or service.'
    },
    {
        img:'https://i.pinimg.com/originals/a3/84/3e/a3843e404a271edb47b1908dd2a6230b.gif',
        name:'Technical Communication',
        description:'Communication is the act of giving, receiving, and sharing information -- in other words, talking or writing, and listening or reading.'
    },
    {
        img:'https://i.gifer.com/7ngr.gif',
        name:'Political Science',
        description:'Political science focuses on the theory and practice of government and politics at the local, state, national, and international levels.'
    }
]

export default Sdata;